import { ShoppingBag, Package, Bell } from "lucide-react";
import { Navbar } from "../components/Navbar";

export default function Marketplace() {
  return (
    <div className="min-h-screen bg-transparent" data-testid="marketplace-page">
      <Navbar />
      <div className="max-w-3xl mx-auto px-6 py-24 text-center">
        <div className="w-24 h-24 bg-[#F2F9F6] rounded-3xl flex items-center justify-center mx-auto mb-8">
          <ShoppingBag className="h-12 w-12 text-[#0B6E4F]" />
        </div>
        <h1 className="font-['Outfit'] text-4xl md:text-5xl font-bold text-[#0F172A] mb-4">
          VitaMarket
        </h1>
        <p className="text-lg text-slate-500 mb-3 font-medium">Coming Soon</p>
        <p className="text-sm text-slate-400 max-w-md mx-auto mb-12 leading-relaxed">
          A marketplace for health & fitness products is on the way. Buy and sell supplements, equipment, apparel, and wellness products — all within VittaNex.
        </p>
        <div className="grid grid-cols-3 gap-6 max-w-sm mx-auto">
          {[
            { icon: Package, label: "Buy & Sell" },
            { icon: ShoppingBag, label: "Curated Products" },
            { icon: Bell, label: "Get Notified" },
          ].map((item, i) => (
            <div key={i} className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 bg-white border border-slate-100 rounded-2xl flex items-center justify-center shadow-sm">
                <item.icon className="h-5 w-5 text-[#0B6E4F]" />
              </div>
              <span className="text-xs text-slate-500 font-medium">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
